import styled from 'styled-components';
import { Icon } from '../../../../components/common/icon/Icon';
import { useCheckUserLoggedIn } from '../../../../hooks/user/useCheckUserLoggedIn';

interface IProductImageOverProps {
  onClick: () => void;
  disableLoginPrompt?: boolean;
}

export const ProductImageOverlay = ({ onClick, disableLoginPrompt = false }: IProductImageOverProps) => {
  const { isUserLoggedIn } = useCheckUserLoggedIn();

  return (
    <>
      {isUserLoggedIn && <OverlayForLoggedInUser />}
      {!isUserLoggedIn && !disableLoginPrompt && <OverlayForAnonymous onClick={onClick} />}
    </>
  );
};

interface IOverlayForAnonymous {
  onClick: () => void;
}

const OverlayForAnonymous = ({ onClick }: IOverlayForAnonymous) => {
  return (
    <AnonymousContainer onClick={onClick}>
      <AnonymousTitle>{'지금 로그인하고\n매물 사진과 가격 확인하기'}</AnonymousTitle>
      <KakaoLoginButton>
        <KakaoIconWrapper>
          <Icon name={'KakaoTalk'} width={24} height={24} />
        </KakaoIconWrapper>
        <KakakoLoginText>{'카카오로 3초만에 로그인'}</KakakoLoginText>
      </KakaoLoginButton>
    </AnonymousContainer>
  );
};

const OverlayForLoggedInUser = () => {
  return (
    <LoggedInUserConatiner>
      <svg xmlns={'http://www.w3.org/2000/svg'} width={'80'} height={'12'} viewBox={'0 0 200 29'} fill={'none'}>
        <g opacity={'0.6'}>
          <path
            d={
              'M65.9118 17.1578C65.4034 18.868 65.0798 20.2084 64.9412 21.1328C64.9412 21.2715 64.71 21.2715 64.71 21.1328C64.6176 20.763 64.5252 20.3471 64.3865 19.7924C64.1554 18.7755 63.9243 17.8973 63.6932 17.1578L59.3484 4.12335L54.7262 4.12335L61.5208 23.4901C62.0292 24.8768 63.3234 25.8474 64.8025 25.8474C66.2816 25.8474 67.622 24.8768 68.0842 23.4901L74.6014 4.12335L69.9793 4.12335L65.9118 17.1578Z'
            }
            fill={'#232429'}
          />
          <path
            d={
              'M24.6361 17.3889L24.6361 4.12335L20.0602 4.12335L20.0602 17.0653C20.0602 17.2965 20.0602 17.5738 20.0602 17.8049C20.0602 17.8511 20.0602 17.8511 20.0602 17.8049C20.3838 21.6413 23.2033 24.7381 26.901 25.6163C26.9934 25.6163 27.0396 25.6625 27.1321 25.6625L27.2245 25.6625C27.5943 25.755 27.9641 25.8012 28.3801 25.8012L32.1702 25.8012L32.1702 21.2715L28.9347 21.2715C26.6699 21.3177 24.821 19.5613 24.6361 17.3889Z'
            }
            fill={'#232429'}
          />
          <path
            d={
              'M47.7006 4.12335L47.7006 17.3427C47.5157 19.5613 45.6669 21.3177 43.4483 21.3177C41.2296 21.3177 39.3345 19.5613 39.1959 17.3427L39.1959 4.12335L34.62 4.12335L34.62 17.0653C34.62 17.2965 34.62 17.5738 34.62 17.8049C34.62 17.8511 34.62 17.8511 34.62 17.8049C34.9435 21.6413 37.763 24.7381 41.4607 25.6163C41.5532 25.6163 41.5994 25.6625 41.6918 25.6625L41.7843 25.6625C42.1541 25.755 42.5238 25.8012 42.9398 25.8012L44.0954 25.8012C44.4651 25.8012 44.8811 25.7087 45.2509 25.6625L45.3433 25.6625C45.4358 25.6625 45.482 25.6163 45.5744 25.6163C49.2259 24.7843 52.0454 21.6413 52.4152 17.8049C52.4152 17.8511 52.4152 17.8511 52.4152 17.8049C52.4152 17.5738 52.4152 17.2965 52.4152 17.0653L52.4152 4.12335L47.7006 4.12335Z'
            }
            fill={'#232429'}
          />
          <path
            d={
              'M93.5058 11.8885C93.5058 11.6574 93.5058 11.3801 93.4596 11.1489C93.4596 11.1027 93.4596 11.1027 93.4596 11.1489C93.1361 7.31257 90.3628 4.21574 86.6651 3.33753C86.5726 3.33753 86.5264 3.29131 86.434 3.29131L86.3415 3.29131C85.9718 3.19886 85.602 3.15265 85.186 3.15265L84.0305 3.15265C83.6607 3.15265 83.2447 3.24509 82.8749 3.29131L82.7825 3.29131C82.69 3.29131 82.6438 3.33753 82.5514 3.33753C78.8999 4.16952 76.1266 7.31257 75.7568 11.1489C75.7568 11.1027 75.7568 11.1027 75.7568 11.1489C75.7568 11.3801 75.7106 11.6574 75.7106 11.8885L75.7106 25.8474L80.2865 25.8474L80.2865 20.7168L88.8375 20.7168L88.8375 25.8474L93.4134 25.8474L93.5058 11.8885ZM80.379 11.7036L80.379 11.5649C80.5176 9.34632 82.4127 7.58991 84.6313 7.58991C86.8962 7.58991 88.745 9.34632 88.8837 11.5649L88.8837 16.1409L80.3327 16.1409L80.379 11.7036Z'
            }
            fill={'#232429'}
          />
          <path
            d={
              'M9.47539 3.10645C9.2905 3.10645 9.10562 3.10645 8.92073 3.10645L8.27363 3.10645C7.90386 3.10645 7.53409 3.1989 7.1181 3.24512L7.02565 3.24512C6.93321 3.24512 6.88699 3.29133 6.79455 3.29133C3.14305 4.16953 0.32355 7.26638 1.72541e-07 11.1028C1.71544e-07 11.0565 1.71544e-07 11.0565 1.72541e-07 11.1028L4.89697e-07 25.8012L4.5297 25.8012L4.5297 19.515C5.77768 20.2084 7.25676 20.6244 8.78207 20.6244C13.4504 20.6244 17.2406 17.0191 17.5641 12.4894L17.5641 12.4432C17.5641 12.2583 17.5641 12.0734 17.5641 11.8885C17.6566 7.22015 14.0513 3.43 9.47539 3.10645ZM8.82829 16.1409C6.471 16.1409 4.5297 14.2458 4.5297 11.8885C4.5297 9.53122 6.471 7.63615 8.82829 7.63615C11.1856 7.63615 13.1269 9.53122 13.1269 11.8885C13.0807 14.1996 11.1856 16.1409 8.82829 16.1409Z'
            }
            fill={'#232429'}
          />
          <path
            d={
              'M175.688 10.9641C173.7 10.9641 172.406 12.4431 172.267 14.2458L178.877 14.2458C178.831 12.3507 177.583 10.9641 175.688 10.9641Z'
            }
            fill={'#232429'}
          />
          <path
            d={
              'M136.492 18.6369C136.492 19.7924 137.463 20.4395 138.849 20.4395C140.837 20.4395 142.085 19.1453 142.085 17.5738L142.131 17.5738L142.131 16.4183C141.53 16.4645 139.681 16.5569 139.034 16.6494C137.463 16.788 136.492 17.3889 136.492 18.6369Z'
            }
            fill={'#232429'}
          />
          <path
            d={
              'M195.101 0.102053L107.835 0.102051C105.154 0.102051 102.935 2.08957 102.935 4.53931L102.935 24.4607C102.935 26.9105 105.107 28.898 107.835 28.898L195.101 28.898C197.781 28.898 200 26.9105 200 24.4607L200 4.53931C200 2.08958 197.781 0.102053 195.101 0.102053ZM131.639 22.5657L128.403 22.5657L128.403 13.6911C128.403 11.9809 127.34 11.1952 126 11.1952C124.336 11.1952 123.457 12.2583 123.457 13.876L123.457 22.6119L120.268 22.6119L120.268 13.6449C120.268 12.2121 119.297 11.2414 117.911 11.2414C116.524 11.2414 115.369 12.3969 115.369 14.1534L115.369 22.6119L112.087 22.6119L112.087 8.60679L115.23 8.60679L115.23 11.0103L115.322 11.0103C115.923 9.39256 117.31 8.46813 119.159 8.46813C121.008 8.46813 122.394 9.43878 122.949 11.0103L123.088 11.0103C123.735 9.485 125.26 8.46813 127.294 8.46813C129.836 8.46813 131.639 10.1321 131.639 13.2751L131.639 22.5657ZM145.32 22.5194L142.177 22.5194L142.177 20.6244L142.085 20.6244C141.484 21.8261 140.19 22.843 137.971 22.843C135.29 22.843 133.303 21.4101 133.303 18.6368C133.303 15.4938 135.845 14.6156 138.479 14.4307C139.45 14.3845 141.437 14.1996 142.038 14.1996L142.038 13.0903C142.038 11.7036 141.114 10.9179 139.542 10.9179C138.11 10.9179 137.185 11.565 136.954 12.5818L133.811 12.5818C134.042 10.2245 136.168 8.4219 139.681 8.4219C142.362 8.4219 145.366 9.53122 145.366 13.2752L145.366 22.5194L145.32 22.5194ZM155.535 11.565C155.258 11.4725 154.564 11.3339 154.056 11.3339C152.253 11.3339 150.913 12.628 150.913 14.3845L150.913 22.5657L147.631 22.5657L147.631 8.56058L150.82 8.56058L150.82 10.9179L150.959 10.9179C151.421 9.30011 152.808 8.42191 154.379 8.46813C154.749 8.46813 155.211 8.46813 155.535 8.51435L155.535 11.565ZM165.473 22.5657L161.22 16.6031L160.018 17.8973L160.018 22.5657L156.691 22.5657L156.691 3.93844L159.972 3.93844L159.972 14.1996L160.203 14.1996L165.195 8.60679L169.032 8.60679L163.67 14.6156L169.355 22.5194L165.473 22.5194L165.473 22.5657ZM182.02 16.4644L172.267 16.4644C172.313 18.8679 173.7 20.2546 175.826 20.2546C177.259 20.2546 178.23 19.6075 178.646 18.8217L181.835 18.8217C181.234 21.2715 179.015 22.843 175.78 22.843C171.574 22.843 169.032 20.0235 169.032 15.6787C169.032 11.3339 171.62 8.46813 175.641 8.46813C179.062 8.46813 181.974 10.5943 182.02 15.4938L182.02 16.4644ZM190.848 22.6581C190.432 22.7043 189.785 22.7505 188.999 22.7505C186.55 22.7505 184.701 21.5488 184.701 18.9142L184.701 11.1028L182.667 11.1028L182.667 8.60679L184.701 8.60679L184.701 5.27885L187.936 5.27885L187.936 8.60679L190.71 8.60679L190.71 11.1028L187.936 11.1028L187.936 18.4057C187.936 19.7462 188.63 20.0235 189.415 20.0697C189.785 20.0697 190.432 20.0235 190.848 20.0235L190.848 22.6581Z'
            }
            fill={'#232429'}
          />
        </g>
      </svg>
    </LoggedInUserConatiner>
  );
};

const Container = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;

  z-index: 5;
`;

const AnonymousContainer = styled(Container)`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  align-self: stretch;

  background: rgba(255, 255, 255, 0.9);
`;

const AnonymousTitle = styled.pre`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/XX-Large/xxl-bold */
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 26px */
`;

const KakaoLoginButton = styled.div`
  width: 250px;
  height: 40px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 16px 8px;

  gap: 10px;

  position: relative;

  border-radius: var(--radius-medium, 8px);
  background: #ffd337;
`;

const KakaoIconWrapper = styled.div`
  position: absolute;
  left: 8px;
  top: 8px;
`;

const KakakoLoginText = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/Large/l-medium */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 20.8px */
`;

const LoggedInUserConatiner = styled(Container)`
  margin: 16px;

  pointer-events: none;
`;
